import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { QuizData } from '../questionaire/QuizData';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
})
export class SidenavComponent {
  lifestyleDone: boolean = false;
  isDoc: boolean = false;
  isCoach: boolean = false;
  patientID: string = this.cookie.get('patientId');


  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );
  isloggedin: boolean;
  sidenavHidden: boolean = false;
  @ViewChild(MatSidenav) sidenav: MatSidenav;

  constructor(private breakpointObserver: BreakpointObserver,
    private _bkoffService: BackOffServiceService,
    private cookie: CookieService,
    private router: Router
  ) { }

  ngOnInit() {
    this.cookie.set("viewPatientTrends", "false");
    this.patientID = this.cookie.get('patientId');
    this.checkLogin();
    this._bkoffService.getisDone().then((res) => {
      console.log(res);
      if (res[0] === true) {
        this.lifestyleDone = true;
        this.cookie.set("lifestyleDone", "true");
      } else {
        this.lifestyleDone = false;
        this.cookie.set("lifestyleDone", "false");
      }
      if (res[1] === true) {
        this.isDoc = true;
        this.cookie.set("doc", "true");
      } else if (res[4] === true) {
        this.isCoach = true;
        this.cookie.set('coach', 'true');
      } else {
        this.isCoach = false;
        this.isDoc = false;
        this.cookie.set('coach', 'false');
        this.cookie.set('doc', 'false');
      }
      if (res[3] === true) {
        this.cookie.set('foodDone', 'true');
      } else {
        this.cookie.set('foodDone', 'false');
      }

    });

    //  this._bkoffService.getisDone().then((res)=>{
    //   if(res[1] == true){
    //     this.isDoc = true;
    //     this.cookie.set("doc", "true");
    //   } else if (res[4] == true){
    //     this.isCoach = true;
    //     this.cookie.set("coach", "true");
    //   } else {
    //     this.isCoach = false;
    //     this.isDoc = false;
    //     this.cookie.set("coach", "false");
    //     this.cookie.set("doc", "false");
    //   }
    //  })

    //  this._bkoffService.getisDone().then((res)=>{
    //   if(res[3] == true){
    //     this.cookie.set("foodDone", "true");
    //   } else {
    //     this.cookie.set("foodDone", "false");
    //   }
    //  })
  }

  checkLogin() {
    if (this.cookie.get('sessionToken')) {
      if (this.cookie.get('isRegistering')) {
        if (!this.cookie.get('isFinishedLogin')) {
          this.isloggedin = false;
          this.sidenavHidden = true;
        } else {
          this.isloggedin = true;
          this.sidenavHidden = false;
        }
      } else {
        this.isloggedin = true;
        this.sidenavHidden = false;
      }
    }
  }

  checkPatient(): Boolean {
    if (this.cookie.get('patientId') === 'none') {
      return false;
    } else {
      return true;
    }
  }

  checkLifestyle(): Boolean {
    if (this.cookie.get('lifestyleDone') === 'true') {
      return true;
    } else {
      return false;
    }
  }

  checkFood(): Boolean {
    if (this.cookie.get('foodDone') === 'true') {
      return true;
    } else {
      return false;
    }
  }

  /*
  checkSdoh(): Boolean {
    if (this.cookie.get('sdohDone') === 'true') {
      return true;
    } else {
      return false;
    }
  }
  */

  checkDoc(): Boolean {
    if (this.cookie.get('doc') === 'true') {
      return true;
    } else {
      return false;
    }
  }

  checkCoach(): Boolean {
    console.log("checking coach");
    if (this.cookie.get('coach') === 'true') {
      return true;
    } else {
      return false;
    }
  }

  checkViewPatientTrends(): Boolean {
    console.log("checking Patient Trends");
    if (this.cookie.get('viewPatientTrends') === 'true') {
      return true;
    } else {
      return false;
    }
  }


  toggleSideNavHidden() {
    this.sidenavHidden = !this.sidenavHidden;
  }

  toggleSignOut() {
    this.sidenavHidden = true;
    this.cookie.deleteAll();
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }

}
